import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { translations } from "../translations";

const HowItWorksContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    minHeight: "auto",
    gap: "24px",
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  background: "var(--overlay-light)",
  borderRadius: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "50%",
  [theme.breakpoints.down("md")]: {
    borderRadius: "20px",
    width: "100%",
    margin: "0 auto",
    overflow: "hidden",
    height: "400px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "300px",
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "50%",
  gap: "32px",
  [theme.breakpoints.down("md")]: {
    padding: "0 20px",
    justifyContent: "center",
    width: "100%",
    gap: "24px",
  },
}));

const StepContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "20px",
  [theme.breakpoints.down("md")]: {
    gap: "16px",
  },
}));

const StepNumber = styled(Box)(() => ({
  width: "45px",
  height: "45px",
  borderRadius: "50%",
  border: "1px solid var(--text-black)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  backgroundColor: "var(--background-white)",
}));

const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: "var(--text-black)",
  marginBottom: "8px",
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
    textAlign: "center",
    marginBottom: "0",
  },
}));

const StepNumberText = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  fontWeight: 500,
  color: "var(--text-black)",
}));

const StepText = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  color: "var(--text-black)",
  maxWidth: "300px",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
    maxWidth: "none",
  },
}));

const StyledImage = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "auto",
    objectFit: "contain",
  },
}));

const howItWorksImg = "/assets/how-it-works.webp";

export default function HowItWorks() {
  const t = translations;

  return (
    <HowItWorksContainer>
      <ImageContainer>
        <StyledImage src={howItWorksImg} alt="How GTC Pay Works" />
      </ImageContainer>

      <ContentContainer>
        <Title variant="h2">{t.howItWorks}</Title>

        <StepContainer>
          <StepNumber>
            <StepNumberText>1</StepNumberText>
          </StepNumber>
          <StepText>{t.step1}</StepText>
        </StepContainer>

        <StepContainer>
          <StepNumber>
            <StepNumberText>2</StepNumberText>
          </StepNumber>
          <StepText>{t.step2}</StepText>
        </StepContainer>

        <StepContainer>
          <StepNumber>
            <StepNumberText>3</StepNumberText>
          </StepNumber>
          <StepText>{t.step3}</StepText>
        </StepContainer>
      </ContentContainer>
    </HowItWorksContainer>
  );
}
